import { configureStore, combineReducers, PreloadedState } from '@reduxjs/toolkit';
import _ from 'lodash';
import { setupListeners } from '@reduxjs/toolkit/query';

import { REDUX_STORAGE_KEY } from 'constants/index';

import { getUserID } from './client/config';
import muxDetails from './mux-details';
import pubnub from './pubnub';
import settings from './settings';
import client from './client';
import login from './login';
import room from './room';
import ui from './ui';

// @ts-expect-error REDUX_STORAGE_KEY is provided to window by SSR
const _window: typeof globalThis & { [REDUX_STORAGE_KEY]: string } = globalThis || {};
const reducer = combineReducers({
  client,
  settings,
  muxDetails,
  pubnub,
  login,
  room,
  ui,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const preloadedState = _window[REDUX_STORAGE_KEY] as any;

if (!_.isEmpty(preloadedState) && !preloadedState.client.auth.isLoggedIn) {
  _.set(preloadedState, 'client.uid', getUserID());
}

export const createReduxStore = (initialState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  });
};

const store = createReduxStore(preloadedState);

export type RootState = ReturnType<typeof reducer>;
export type AppStore = ReturnType<typeof createReduxStore>;
export type AppDispatch = AppStore['dispatch'];

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export { reducer };
export default store;
